<template>
  <v-data-table
    data-app
    class="tabela-justificativas"
    :items="formattedItems"
    :headers="headers"
    hide-default-footer
    :items-per-page="-1"
  >
    <template v-slot:item="{ item }">
      <tr class="table-v-tr" :class="{ 'row-erro': errosItem(item).length }" style="cursor: default">
        <td
          v-for="col in headers"
          :key="col.value"
          :class="{ nowrap: col.nowrap, 'col-fixa': col.fixa }"
          :style="{ 'text-align': col.textAlign }"
        >
          <div
            v-if="col.value === 'matricula'"
            class="d-flex text-truncate"
            style="min-width: 150px"
          >
            <v-tooltip bottom v-if="errosItem(item).length">
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-on="on"
                  v-bind="attrs"
                  class="indicador-erro"
                  data-testid="indicador-erro-linha"
                ></div>
              </template>
              <div v-for="(erro, i) in errosItem(item)" :key="i">{{ erro }}</div>
            </v-tooltip>
            <span>{{ item.matricula }}</span>
          </div>

          <div
            v-else-if="col.value === 'nome'"
            class="d-flex text-truncate"
            style="min-width: 250px"
            :title="item.nome"
          >
            <span>{{ item.nome }}</span>
          </div>

          <div
            v-else-if="col.value === 'cpf'"
            class="text-truncate"
            style="min-width: 150px"
          >
            <div class="d-flex">{{ item.cpf ? $options.filters.toCPF(item.cpf) : "" }}</div>
            <div
              v-if="!item.cpf || (item.cpf.length !== 11 && item.cpf.length !== 14) || !validateCPF(item.cpf)"
              style="color: red; font-size: 10px"
            >
              CPF do colaborador está inválido.
            </div>
          </div>

          <div
            v-else-if="col.value === 'sexo'"
            class="text-truncate"
            style="min-width: 150px"
          >
            <div class="d-flex">{{ item.sexo ? item.sexo : "" }}</div>
            <div
              v-if="!item.sexo || item.sexo.length === 0"
              style="color: red; font-size: 10px"
            >
              Sexo do colaborador está inválido.
            </div>
          </div>

          <div
            v-else-if="col.value === 'escolaridade'"
            class="text-truncate"
            style="min-width: 120px"
          >
            <div class="d-flex">{{ item.escolaridade ? item.escolaridade : "" }}</div>
            <div
              v-if="
                !item.escolaridade ||
                item.escolaridade.length === 0 ||
                (trabalho === 1 && !opcoesEscolaridadeLB.includes(item.escolaridade.toLowerCase()))
              "
              style="color: red; font-size: 10px"
            >
              Escolaridade do colaborador está inválida.
            </div>
          </div>

          <div
            v-else-if="col.value === 'dedicacao'"
            class="text-truncate"
            style="min-width: 120px"
          >
            <div class="d-flex">{{ item.dedicacao ? item.dedicacao : "" }}</div>
            <div
              v-if="!item.dedicacao || item.dedicacao.length === 0"
              style="color: red; font-size: 10px"
            >
              Dedicação do colaborador está inválida.
            </div>
          </div>

          <div
            v-else-if="col.value === 'justificativa'"
            :title="item.justificativa"
            @click="$emit('edit', item)"
          >
            <div class="d-flex">
              <div class="cursor-pointer text-truncate" style="max-width: 350px">
                {{ item.justificativa || "Nenhuma justificativa." }}
              </div>
            </div>
            <div
              v-if="item.justificativa && item.justificativa.length > 3000"
              style="color: red; font-size: 10px"
            >
              Texto de justificativa ultrapassou o limite de caracteres.
            </div>
            <div
              v-else-if="!item.justificativa || item.justificativa.length === 0"
              style="color: red; font-size: 10px"
            >
              Texto de justificativa é obrigatório.
            </div>
          </div>

          <div
            v-else-if="col.value === 'funcao_projeto'"
            class="cursor-pointer text-truncate"
            style="max-width: 300px"
            :title="item.funcao_projeto"
            @click="$emit('edit', item)"
          >
            <div class="d-flex">
              {{ item.funcao_projeto || "Nenhuma função no projeto." }}
            </div>
            <div
              v-if="item.funcao_projeto && item.funcao_projeto.length > 100"
              style="color: red; font-size: 10px"
            >
              Texto de função no projeto ultrapassou o limite.
            </div>
            <div
              v-else-if="!item.funcao_projeto || item.funcao_projeto.length === 0"
              style="color: red; font-size: 10px"
            >
              Texto de função no projeto é obrigatório.
            </div>
          </div>

          <v-btn
            v-else-if="col.value === 'atividades'"
            color="primary"
            icon
            @click="$emit('open-atividades', item.atividades, item)"
          >
            <v-icon large>mdi-card-search</v-icon>
          </v-btn>

          <template v-else>
            {{ col.format ? col.format(item[col.value]) : item[col.value] }}
          </template>
        </td>
      </tr>
    </template>

    <template v-slot:[`body.append`]="append" v-if="projetoWrapper.total">
      <tr class="table-v-tr">
        <th
          style="cursor: default; font-size: 13px !important"
          v-for="col in append.headers"
          :key="col.value"
          :class="{ nowrap: col.nowrap, 'col-fixa': col.fixa }"
          :style="{ 'text-align': col.textAlign }"
        >
          {{ col.format ? col.format(projetoWrapper.total[col.value]) : projetoWrapper.total[col.value] }}
        </th>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { getErrosColaborador, opcoesEscolaridadeLB } from "@/core/utils/validacoesJustificativas";
import { validateCPF } from "@/helpers/masks";

export default {
  name: "TableColaboradores",
  props: {
    projetoWrapper: {
      type: Object,
      required: true,
    },
    trabalho: {
      type: Number,
      required: true,
    },
    somenteErros: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opcoesEscolaridadeLB,
    };
  },
  methods: {
    validateCPF,
    errosItem(item) {
      return getErrosColaborador(item, this.trabalho);
    },
  },
  computed: {
    formattedItems() {
      const itens = this.projetoWrapper.colaboradores || [];
      if (this.somenteErros) {
        return itens.filter((item) => this.errosItem(item).length);
      }
      return itens;
    },
    headers() {
      const allCols = [
        {
          text: "Matrícula",
          value: "matricula",
          width: "120px",
        },
        {
          text: "Nome",
          value: "nome",
          width: "14%",
          fixa: true,
          class: "col-fixa",
        },
        {
          text: "CPF",
          value: "cpf",
          nowrap: true,
          width: "14%",
        },
        {
          text: "Sexo",
          value: "sexo",
          nowrap: true,
          width: "100px",
          show: this.trabalho == 1 ? true : false,
        },
        {
          text: "Escolaridade",
          value: "escolaridade",
          width: "150px",
        },
        {
          text: "Tipo RH",
          value: "tipo_rh",
          width: "14%",
          show: this.trabalho == 2 ? true : false,
        },
        {
          text: "Atuação",
          value: "atuacao",
          width: "14%",
          show: this.trabalho == 2 ? true : false,
        },
        {
          text: "Dedicação",
          value: "dedicacao",
          nowrap: true,
          width: "150px",
          show: this.trabalho == 1 ? true : false,
        },
        {
          text: "Horas",
          value: "horas",
          nowrap: true,
          width: "100px",
          format: (value) => {
            if (value || value == 0) {
              return parseFloat(value).toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
            }
            return "";
          }
        },
        {
          text: "Valor",
          value: "valor",
          nowrap: true,
          width: "14%",
          format: (value) => {
            if (value || value == 0) {
              return parseFloat(value).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
            }
            return "";
          }
        },
        {
          text: "Função no projeto",
          value: "funcao_projeto",
          width: "14%",
          show: this.trabalho == 1 ? true : false,
        },
        {
          text: "Justificativa",
          value: "justificativa",
          width: "14%",
        },
        {
          text: "",
          value: "atividades",
          show: this.trabalho == 2 ? true : false,
          width: "14%",
        },
      ];

      return allCols.filter(({ show }) => show !== false);
    },
  },
};
</script>

<style scoped>
.table-v-tr:hover {
  background-color: #f5f5f5;
}
.row-erro {
  background-color: #fff5f5;
}
.indicador-erro {
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 100%;
  margin-right: 5px;
  margin-top: 4px;
  flex-shrink: 0;
}
.cursor-pointer {
  cursor: pointer;
}
.nowrap {
  white-space: nowrap;
}
</style>
